import { extendTheme } from '@mui/material/styles';

const theme = extendTheme({
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    main: '#d02b2d',
                },
                secondary: {
                    main: '#242a33',
                },
            },
        },
    },
    typography: {
        fontFamily: "'Sora', 'Roboto', sans-serif",
    },
});

export default theme;